import { observer } from 'mobx-react-lite';
import { Skeleton } from '../../components/Skeleton';
import { ServiceStore } from '../../stores/serviceStore';
import { Category } from '../Rooms/Category';
import { Service } from './Service';

type ServiceListProps = {
  serviceStore: ServiceStore;
  params: { from?: Date; to?: Date };
};

export const ServiceList = observer(({ serviceStore, params }: ServiceListProps) => {
  const { pending, category, categories, setCategory } = serviceStore.serviceList;

  return (
    <>
      <section className="flex space-x-4 overflow-auto px-5 pb-8 xl:space-x-7 xl:px-0 xl:pb-5 3xl:absolute 3xl:left-[78px] 3xl:flex-col 3xl:space-x-0 3xl:space-y-4">
        {pending && (
          <>
            <Skeleton loading className="h-7 w-[80px]"></Skeleton>
            <Skeleton loading className="h-7 w-[80px]"></Skeleton>
          </>
        )}
        {!pending &&
          categories.map(cat => (
            <Category key={cat} selected={category === cat} onClick={setCategory}>
              {cat}
            </Category>
          ))}
      </section>

      {serviceStore.serviceList.getListByCategory().map(service => (
        <Service
          onClick={params => serviceStore.onServiceClick(params)}
          serviceStore={serviceStore}
          params={params}
          key={service.id}
          service={service}
        />
      ))}
    </>
  );
});
